export default "__VITE_ASSET__90eFcNF5__"